(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('ReceiptContinueAMLDialogController', ReceiptContinueAMLDialogController);

    ReceiptContinueAMLDialogController.$inject = ['$scope', '$uibModalInstance'];

    function ReceiptContinueAMLDialogController ($scope, $uibModalInstance) {
    	var continueAMLDlgCtr = this;
    	continueAMLDlgCtr.confirm= confirm;
    	function confirm(numChoose) {
        	$uibModalInstance.close(numChoose);
        }
    }
})();
